<template>
  <div>
    <div class="row">
      <div class="col-xs-6">
        <p class="customer holder">
          <strong>Nome:</strong> {{ ticket.customer.holder }} </p>
        <p class="customer uc"><strong>UC:</strong> {{ ticket.customer.uc }}</p>
        <p class="customer cpf"><strong>CPF:</strong> {{ ticket.customer.cpf }} </p>
      </div>
      <div class="col-xs-6 text-center">
        <div class="barcode">
          <img :id="`barcodeCanvas-${ticket._id}`"></img>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <p style="color: #aaaaaa; margin-bottom: 0.5em; text-align: right; font-size: 5pt;">
          {{ `${ticket.eventId} - ${ticket._id}` }}
        </p>
      </div>
    </div>

    <ParticipationTerm
      :ticket="ticket"
      :loading="loading"
    />

    <div class="row" v-if="ticket.user">
      <div class="col-xs-12"><p>Ticket gerado por: <b>{{ ticket.user.name }}</b></p></div>
    </div>
  </div>
</template>
<script>
  import ParticipationTerm from './Terms/ParticipationTerm'
  import JsBarcode from 'jsbarcode'

  export default {
    name: 'ticket-document',

    components: {
      ParticipationTerm
    },

    data () {
      return {
        loaded: false
      }
    },

    props: {
      loading: {},
      ticket: {}
    },

    watch: {
      ticket (ticket) {
        this.makeBarcode()
      }
    },

    computed: {
      config: {
        get () {
          return this.$store.state.config
        }
      },

      imgId () {
        return 'img-barcodeCanvas-' + this.ticket._id
      }
    },

    methods: {
      makeBarcode () {
        JsBarcode('#barcodeCanvas-' + this.ticket._id, this.ticket.barcode, {
          lineColor: '#000',
          fontSize: '16pt',
          width: 1,
          height: 50,
          displayValue: true
        })
      }
    },

    mounted () {
      this.makeBarcode()
    }
  }
</script>
<style scoped>

  .customer {
    font-size: 10pt;
  }

  strong {
    font-weight: bolder;
  }

  @page {
    size: A4 portrait;
    margin: 1em;  /* this affects the margin in the printer settings */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/TicketDocument.vue